import React, { useEffect, useState } from 'react';
import ModalContainer from '../../components/ModalContainer.jsx';
import { Form, Formik } from 'formik';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import GetField from '../../components/GetField.jsx';
import { initialValues, initialTouched, onSubmit, validationSchema } from './addDiscountFormikCodes.js';
import { convertDateToJalaali } from '../../utils/convertDate.js';


const options = [
    {
        value: "a",
        text: "مبلغ"
    },
    {
        value: "p",
        text: "درصد"
    }
];

const AddDiscount = () => {
    const [reinitializeValues, setReinitializeValues] = useState(null);

    const { setDiscounts } = useOutletContext();

    const navigate = useNavigate();
    const location = useLocation();

    const handleChangeCouponType = (ev, formik) => {
        const value = ev.target.value;
        if (value === "p") {
            formik.setFieldError("amount", "");
        } else {
            formik.setFieldError("percent", "");
        }
        formik.setFieldValue("coupon_type", value);
    }

    useEffect(() => {
        if (location.state) {
            setReinitializeValues({
                title: location.state.title,
                code: location.state.code,
                coupon_type: location.state.coupon_type,
                amount: location.state.amount || "",
                percent: location.state.percent || "",
                start_date: convertDateToJalaali(location.state.start_date),
                end_date: convertDateToJalaali(location.state.end_date),
                min_spend: location.state.min_spend,
                max_discount: location.state.max_discount,
                is_active: location.state.is_active
            });
        } else {
            setReinitializeValues(null);
        }
    }, []);

    return (
        <ModalContainer
            alwaysOpen={true}
            fullscreen={false}
            title={location.state ?
                `ویرایش تخفیف "${location.state.title}"` :
                "افزودن تخفیف"
            }
        >
            <Formik
                initialValues={reinitializeValues || initialValues}
                initialTouched={reinitializeValues ? initialTouched : {}}
                onSubmit={(values, actions) => onSubmit(values, actions, location.state, setDiscounts, navigate)}
                validationSchema={validationSchema}
                enableReinitialize
                validateOnMount
            >
                {(formik) => {
                    return (
                        <Form className="flex flex-col 
                            items-center">
                            <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="title"
                                    type="text"
                                    placeholder="عنوان تخفیف"
                                    label="عنوان"
                                    formik={formik}
                                />
                            </div>
                            <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="code"
                                    type="text"
                                    placeholder="کد تخفیف"
                                    label="کد"
                                    formik={formik}
                                />
                            </div>
                            <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="select"
                                    name="coupon_type"
                                    formik={formik}
                                    options={options}
                                    label="حالت تخفیف:"
                                    title="لطفا یک حالت را انتخاب کنید"
                                    onChange={(ev) => handleChangeCouponType(ev, formik)}
                                />
                            </div>
                            {formik.values.coupon_type === "p" ? (
                                <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                                    <GetField
                                        control="input"
                                        name="percent"
                                        type="text"
                                        placeholder="درصد تخفیف"
                                        label="درصد"
                                        formik={formik}
                                    />
                                </div>
                            ) : formik.values.coupon_type === "a" && (
                                <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                                    <GetField
                                        control="input"
                                        name="amount"
                                        type="text"
                                        placeholder="مبلغ تخفیف"
                                        label="مبلغ"
                                        formik={formik}
                                    />
                                </div>
                            )}
                            <div className="mb-6 mt-1 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="datepicker"
                                    name="start_date"
                                    label="تاریخ شروع:"
                                    placeholder="تاریخ شروع تخفیف"
                                    formik={formik}
                                    yearRange={{
                                        from: 10, to: 10
                                    }}
                                    initialDate={location.state ? location.state.start_date : ""}
                                />
                            </div>
                            <div className="mb-6 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="datepicker"
                                    name="end_date"
                                    label="تاریخ پایان:"
                                    placeholder="تاریخ پایان تخفیف"
                                    formik={formik}
                                    yearRange={{
                                        from: 10, to: 10
                                    }}
                                    initialDate={location.state ? location.state.end_date : ""}
                                />
                            </div>
                            <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="min_spend"
                                    type="text"
                                    placeholder="حداقل مبلغ تخفیف"
                                    label="حداقل مبلغ"
                                    formik={formik}
                                />
                            </div>
                            <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="input"
                                    name="max_discount"
                                    type="text"
                                    placeholder="حداکثر مبلغ تخفیف"
                                    label="حداکثر مبلغ"
                                    formik={formik}
                                />
                            </div>
                            <div className="mb-5 w-full md:w-4/6 max-w-screen-sm">
                                <GetField
                                    control="switch"
                                    name="is_active"
                                    label="کد تخفیف فعال شود"
                                />
                            </div>
                            <div className="w-full text-center mt-4">
                                <GetField
                                    control="submitbutton"
                                    disabledButton={true}
                                    formik={formik}
                                    text={location.state ? "ویرایش تخفیف" : "افزودن تخفیف"}
                                />
                            </div>
                        </Form>
                    );
                }}
            </Formik>
        </ModalContainer>
    );
}

export default AddDiscount;
